import type { SVGProps } from 'react';
const SvgRiceBowl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#rice_bowl_svg__a)">
      <path
        fill="currentColor"
        d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25Zm-2 0h-4V5.08c2.39 1.39 4 3.97 4 6.92Zm-6-7.74V12h-4V4.26c.64-.16 1.31-.26 2-.26s1.36.1 2 .26ZM4 12c0-2.95 1.61-5.53 4-6.92V12H4Z"
      />
    </g>
    <defs>
      <clipPath id="rice_bowl_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRiceBowl;
